module.exports = __webpack_public_path__ + "static/media/helping-others@2x.a6de0dec.png";